import React from 'react';

import { Invite, Reservation, VennueAccessRequestItem, VenueReservationContentItemV2 } from '../../graphql/API';

export type NotificationsContextProps = {
  lastReservationCreatedAtTime: string;
  lastCollabUpdatedAtTime: string;
  lastContentUpdatedAtTime: string;
  lastAccessRequestUpdatedAtTime: string;
  invite: Invite | null;
  reservation: Reservation | null;
  content: VenueReservationContentItemV2 | null;
  accessRequest: VennueAccessRequestItem | null;
  handleUpdateReservation: (val: string) => void;
  handleUpdateInvite: (val: string) => void;
  handleUpdateContent: (val: string) => void;
  handleUpdateAccessRequest: (val: string) => void;
  refetchReservationsHandler: () => void;
};

export const NotificationsContext = React.createContext<NotificationsContextProps | undefined>(
  undefined,
);

export const useNotificationsContext = () => React.useContext(NotificationsContext);
